import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import ectoollogo from "../../assets/images/ectool_Logo_2019.png";
import { Card, CardContent, Grid, Button, Box, Typography } from "@mui/material";
import { VERSION } from "../../constants/version";
import { useMessage } from "../../context/message-context";
import { isBrowser, isMobile, osName, osVersion, browserVersion, browserName, mobileModel } from "react-device-detect";
import { useNotification } from "../../context/notification-context";
import { useAsync, useLocalStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useAuth } from "../../context/auth-context";
import { useGlobalState } from "../../context/global-state-context";
import { DEBUG_FLAG } from "../../constants/debug";
import { FullPageSpinner } from "../lib";
function LoginForm(props) {
  const { t } = useTranslation();
  const { doPasswordLogin } = props;
  const [deviceVersion] = useState(localStorage.getItem(LOCAL_STORAGE_KEY.version) || VERSION);
  const { showErrorMessage } = useMessage();
  const notificationToken = useNotification();
  const [, setRefreshToken] = useLocalStorage(LOCAL_STORAGE_KEY.refreshToken);
  const [deviceId] = useLocalStorage(DEBUG_FLAG() ? LOCAL_STORAGE_KEY.deviceIdLocal : LOCAL_STORAGE_KEY.deviceId);
  const { tokenRefresh } = useAuth();
  const { isError, isLoading, error, run } = useAsync();
  const [globalState, setGlobalState] = useGlobalState();
  useEffect(() => {
    if (globalState.firstLogin) {
      setGlobalState("firstLogin", false);
      if (window.cordova) {
        deviceAuthentication();
      } else {
        setRefreshToken("");
      }
    }
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (isError) {
      showErrorMessage(error.message);
    }
  }, [isError, error, showErrorMessage]);
  const deviceAuthentication = () => {
    switch (window.cordova.platformId) {
      case "android":
        const username = localStorage.getItem(LOCAL_STORAGE_KEY.username);
        const androidToken = localStorage.getItem(LOCAL_STORAGE_KEY.androidToken);
        var decryptConfig = {
          clientId: "ectool",
          username: username.replace("/", ""),
          token: androidToken,
          maxAttempts: 5,
          locale: "de",
          dialogTitle: "Authorisierung",
          dialogMessage: "Bitte legen Sie Ihren Finger auf",
        }; // See config object for required parameters
        console.log(androidToken);
        try {
          window.FingerprintAuth.isAvailable(
            function (result) {
              console.log("FingerprintAuth available: " + JSON.stringify(result));
              // If has fingerprint device and has fingerprints registered
              if (result.isAvailable === true && result.hasEnrolledFingerprints === true) {
                window.FingerprintAuth.decrypt(
                  decryptConfig,
                  (_fingerResult) => {
                    console.log("successCallback(): " + JSON.stringify(_fingerResult));
                    var payload = {
                      deviceId: deviceId,
                      notifToken: notificationToken,
                      device: mobileModel,
                      os: osName,
                      osBez: mobileModel + " " + osName + " " + osVersion,
                      clientVersion: deviceVersion,
                      clientBuild: VERSION,
                    };
                    run(tokenRefresh(payload));
                  },
                  (error) => {
                    if (error === "Cancelled") {
                      console.log("FingerprintAuth Dialog Cancelled!");
                    } else {
                      console.log("FingerprintAuth error: " + error);
                      showErrorMessage(t("Geräteauthentifizierung nicht möglich"));
                    }
                  }
                );
              }
            },
            function (message) {
              console.log("isAvailableError(): " + message);
              showErrorMessage(t("Geräteauthentifizierung nicht möglich"));
            }
          );
        } catch (error) {}
        break;
      case "ios":
        window.CID.checkAuth(
          "Login",
          function (res) {
            if (res === "success") {
              var payload = {
                deviceId: deviceId,
                notifToken: notificationToken,
                device: mobileModel,
                os: osName,
                osBez: mobileModel + " " + osName + " " + osVersion,
                clientVersion: deviceVersion,
                clientBuild: VERSION,
              };
              console.log("deviceId", deviceId);
              run(tokenRefresh(payload));
            } else {
              console.log(res);
            }
          },
          function (err) {
            console.log(err);
            showErrorMessage(t("Geräteauthentifizierung nicht möglich"));
          }
        );
        break;
      default:
        showErrorMessage(t("Geräteauthentifizierung nicht möglich"));
        break;
    }
  };
  return (
    <Box p={2}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} sm={8} md={6}>
              <Card>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <img src={ectoollogo} height="50" alt="ectool" loading="lazy" />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h5">{t("Willkommen zurück")}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Button variant="contained" color="primary" onClick={() => deviceAuthentication()}>
                        {t("Mit Gerät authentifizieren")}
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Button onClick={() => doPasswordLogin()}>{t("Passwort eingeben")}</Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {isLoading && <FullPageSpinner />}
    </Box>
  );
}
export default LoginForm;
